import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CourierProcessTab1 = () => {
    const [couriers, setCouriers] = useState([]);
    const [uploadType, setUploadType] = useState('pincode');
    const [selectedCourier, setSelectedCourier] = useState('');
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchCouriers = async () => {
            try {
                const response = await axios.get('https://astrovidhya.in/api/couriers/active');
                setCouriers(response.data);
            } catch (err) {
                setError('Failed to fetch courier list.');
            }
        };

        fetchCouriers();
    }, []);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (!selectedCourier) {
            setError('Please select a courier.');
            return;
        }

        if (!file) {
            setError('Please select a file to upload.');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('uploadType', uploadType);
        formData.append('courierId', selectedCourier);

        try {
            await axios.post('https://astrovidhya.in/api/courier-process-tab1/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            setMessage('File uploaded successfully.');
            setFile(null);
        } catch {
            setError('Failed to upload file. Please try again.');
        }
    };

    const [dropdownOpen, setDropdownOpen] = useState(false);
   
    

    return (
        <div className="min-h-[85vh] bg-gray-100 flex flex-col items-center py-10 px-6">
            <div className="w-full max-w-3xl bg-white shadow-lg rounded-lg p-6">
                <h3 className="text-2xl font-bold text-[#000000] mb-6">
                    Courier Process - Upload
                </h3>
                {error && <div className="text-red-500 bg-red-100 p-3 rounded mb-4">{error}</div>}
                {message && <div className="text-green-500 bg-green-100 p-3 rounded mb-4">{message}</div>}

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <div>
    <label className="block text-gray-700 font-medium mb-2">Upload Type:</label>
    <div className="flex space-x-4">
        <label className="flex items-center space-x-2">
            <input
                type="radio"
                name="uploadType"
                value="pincode"
                checked={uploadType === 'pincode'}
                onChange={(e) => setUploadType(e.target.value)}
                className="h-5 w-5 accent-[#03C9D7] focus:ring-[#03C9D7]"
            />
            <span>PIN Number</span>
        </label>
        <label className="flex items-center space-x-2">
            <input
                type="radio"
                name="uploadType"
                value="awd"
                checked={uploadType === 'awd'}
                onChange={(e) => setUploadType(e.target.value)}
                className="h-5 w-5 accent-[#03C9D7] focus:ring-[#03C9D7]"
            />
            <span>AWD Number</span>
        </label>
    </div>
</div>

                    </div>

                    <div className="relative">
  <label className="block text-gray-700 font-medium mb-2">Select Courier:</label>
  <div className="relative">
    <button
      type="button" /* Ensure it doesn't trigger form submission */
      className="w-full border border-gray-300 rounded-md p-2 bg-white text-left focus:outline-none focus:ring-2 focus:ring-[#03C9D7]"
      onClick={(e) => {
        e.stopPropagation(); // Prevents bubbling up to the form
        setDropdownOpen((prev) => !prev);
      }}
    >
      {selectedCourier
        ? couriers.find((c) => c._id === selectedCourier)?.name || "Select Courier"
        : "-- Select Courier --"}
    </button>

    {dropdownOpen && (
      <ul
        className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-md max-h-60 overflow-y-auto"
        onClick={(e) => e.stopPropagation()} // Prevent closing dropdown on click
      >
        {couriers.map((courier) => (
          <li
            key={courier._id}
            onClick={() => {
              setSelectedCourier(courier._id);
              setDropdownOpen(false);
            }}
            className="cursor-pointer px-4 py-2 hover:bg-[#03C9D7] hover:text-white transition"
          >
            {courier.name}
          </li>
        ))}
      </ul>
    )}
  </div>
</div>


                    <div>
                        <label className="block text-gray-700 font-medium mb-2">File:</label>
                        <input
                            type="file"
                            accept=".csv"
                            onChange={handleFileChange}
                            className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-[#03C9D7]"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-[#03C9D7] hover:bg-[#02A5B3] text-white font-semibold py-2 px-6 rounded shadow-md transition duration-300"
                    >
                        Upload
                    </button>
                </form>
            </div>
        </div>
    );
};

export default CourierProcessTab1;
